export default "__VITE_ASSET__c35d3a78__"